<h4 class="mb-2" [class.text-white]="color === 'white'">Tools & Technologies</h4>
<div class="mb-2" *ngFor="let t of keys">
  <div class="technology-list-item">
    <img [src]="'../../assets/img/' + technologies[t].image" [alt]="technologies[t].name" />
  </div>
</div>